import React , {useState , useEffect}  from "react";
import styled, { keyframes } from "styled-components";
import BusinessCardHeader from "./BusinessCardHeader";
import BusinessCardAbout from './BusinessCardAbout';
import ActionsListContainer from './ActionsListContainer';
import {FadeIn} from '../../../libs/components/FadeIn'
import {Button} from "../../../libs/components/Button";
import CardGallery from '../CardGallery';
import icons from '../../Icons/icons';
import SharingOptions from './Share';
import {Modal} from '../../../libs/components/Modal';
import BusinessDetails from './businessDetails';
import {components as actionComponents} from '../../Action';
import BusinessCardFooterContainer from "./BusinessCardFooterContainer";
import BusinessDetailes from "./businessDetails";
// import styles from '@brainhubeu/react-carousel/lib/style.css';

const ActionsContainer = actionComponents.ActionsListContainer;

const BusinessCardLayout = styled.div`
  id: 
  position: relative;
  direction: ${(props) => props.direction ? props.direction : 'rtl'};
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor : 'white'};
  
  max-width: 1200px;
  margin: auto;
  min-height: 100%;
`;

const BusinessCardDetails = styled.div`
  background-image: ${(props) => props.backgroundImage ? 'url('+props.backgroundImage+')' : 'none'};
  // background-size: cover;
  background-size: cover;
  padding-bottom: 50px;
`;

const getBackgroundImages = (backgroundImage) => {
    if(backgroundImage.isLocal){
        return backgroundImage.images ? backgroundImage.images.file : 'images/none';
    }
    else{
        return backgroundImage.images ? backgroundImage.images.lg.replace(/\\/g, '/') : 'images/none';
    }
}

//TODO: add images prop
export default function BusinessCard({ cardConfig , cardUrl }) {


  console.log('card config');
  console.log(cardConfig);


  const cardSettings = cardConfig.settings;
  const cardImages= cardConfig.images;
  const clientInfo = cardConfig.clientInfo;
  const [shareModalOpen,setShareModalOpen] = useState(false);
  const actionsColor = cardSettings.actionsSettings.color;
  const [isLoading,setIsLoading] = useState(true);

  //TODO: fix the value of isResponsive should be boolean
  const backgroundImage = getBackgroundImages(cardImages.backgroundImage);

  //chnage later to a spinner instead of text 
  // useEffect(()=>{
  //   setIsLoading(false);
  // },[]);
  console.log(`background image`);
  console.log(backgroundImage);
  console.log(`cardSettings.actions:`)
  console.log(cardSettings.actions);

  return (
    // isLoading 
    // ? 
    // <div>Loading...</div>
    // :
    <BusinessCardLayout 
      id="BusinessCard" 
      direction={cardSettings.bodySettings.direction}
      backgroundColor={cardSettings.backgroundSettings.backgroundColor} 
    >
      <BusinessCardDetails id="cardImage"
      backgroundImage={backgroundImage}>
      <BusinessCardHeader 
        title={cardSettings.headerSettings.title} 
        subTitle={cardSettings.headerSettings.subTitle} 
        avatar={cardImages.avatar}
        // avatarOffset={cardSettings.headerSettings.logoOffset}
        headerImage={cardImages.headerImage}
        titleColor={cardSettings.headerSettings.titleColor}
        titleFontWeight={cardSettings.headerSettings.titleFontWeight}
        subtitleColor={cardSettings.headerSettings.subtitleColor}
        />
      <ActionsListContainer/>
      <FadeIn>
        <Button text={cardSettings.bodySettings.direction === 'rtl' ? 'הוסף אותי לאנשי הקשר' : 'Add Contact'} color={actionsColor} link={`vcard/${clientInfo.businessname}.vcf`} fontColor={cardSettings.actionsSettings.fontColor} isDownload={true}/> 
      </FadeIn>
        {
          clientInfo.about ?
          <BusinessCardAbout about={clientInfo.about} direction={cardSettings.bodySettings.direction} fontColor={cardSettings.bodySettings.fontColor}/>
          :
          null
        }
        {
          // clientInfo.openingHours &&? 
          true ?
          <BusinessDetails 
          servicesDescription={clientInfo.servicesDescription} 
          servicesTitle={cardSettings.detailsSettings.servicesTitle}
          openingHours={clientInfo.openingHours} 
          openingHoursTitle={cardSettings.detailsSettings.openingHoursTitle}
          direction={cardSettings.bodySettings.direction === 'rtl' ? 'right' : 'left'}
          color={actionsColor} />
          : 
          null
        }
        </BusinessCardDetails>
        {
          cardImages.galleryImages.length > 0 ?
          //TODO: set images prop from images
          <CardGallery images={cardImages.galleryImages} title={cardSettings.headerSettings.title} /> 
          : null
        }
        <SharingOptions cardUrl={cardUrl} title={cardSettings.shareSettings.title}/>
        <Modal isModalOpen={shareModalOpen} onCloseModal={() => setShareModalOpen(false)}>
          <SharingOptions/>
        </Modal>
        <BusinessCardFooterContainer/>
    </BusinessCardLayout>
  );
}
